var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcDownArrow = function SvgIcDownArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.317 14.531a.753.753 0 0 1-1.062 0L2.47 9.762a.747.747 0 0 1 0-1.059.753.753 0 0 1 1.062 0l3.504 3.492V2.513a.75.75 0 1 1 1.5 0v9.682l3.504-3.492a.753.753 0 0 1 1.063 0 .747.747 0 0 1 0 1.059l-4.786 4.77Z"
  })), "/");
};
export default SvgIcDownArrow;